import EtReference from '@/features/config/pages/EtReference/EtReference'
import useTranslation from '@/hooks/useTranslation'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import { Box, Stack, Typography } from '@mui/material'
import type { GuidedStepComponentProps } from '../guidedSteps'

/**
 * SCRUM-1032 / SCRUM-1037 — Guided ET Reference step.
 *
 * Embeds the /config ET Reference grid scoped to the setup interface id (never the globally-selected
 * interface — SCRUM-976). EtReference has no page chrome of its own; its add/edit drawer + delete
 * dialog are hosted centrally by SetUpGuided (ConfigUIProvider + SidebarUI/ModalUI reused from
 * ConfigContainer), so this step only renders the grid.
 *
 * ET Reference never holds Next (see `guidedStepGaps`), but nothing on the step said so: the rail
 * only reads "optional" once the step has been left empty. The note says it up front.
 */
const EtReferenceStep = ({ interfaceId }: GuidedStepComponentProps) => {
  const { t } = useTranslation()

  return (
    <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column', p: '24px' }}>
      <Stack
        direction="row"
        alignItems="center"
        spacing="8px"
        data-testid="et-reference-optional-note"
        sx={{
          mb: '12px',
          px: '12px',
          py: '8px',
          borderRadius: '8px',
          border: '1px solid',
          borderColor: 'border.main',
          backgroundColor: 'background.overrideDefault',
          flexShrink: 0,
        }}
      >
        <InfoOutlinedIcon sx={{ fontSize: 16, color: 'text.main', flexShrink: 0 }} />
        <Typography sx={{ fontSize: '13px', color: 'text.main', lineHeight: 1.3 }}>
          {t('guidedSetupEtReferenceOptional')}
        </Typography>
      </Stack>
      <EtReference interfaceId={interfaceId} />
    </Box>
  )
}

export default EtReferenceStep
